module.exports = __webpack_public_path__ + "img/bg_spa.188aa3d9.jpg";